import { UsersService } from '../users/users.service';
import * as i0 from "@angular/core";
import * as i1 from "../users/users.service";
export class PrivilegesService {
    constructor(usersService) {
        this.usersService = usersService;
        this.privilagesEventType = {
            'training': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
            },
            'outside_distributor': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
            },
            'masterclass': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
            },
            'trade_meeting': {
                'event': {
                    'check_presence': 1,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
            },
            'education_meeting': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
            },
            'influential_event': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
            },
            'salon_training': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 2,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
            },
            'terrain_visit': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
            },
            'other': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
            },
            'salon_training_paid': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 2,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
            },
            'salon_training_turnover': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 2,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
            },
        };
        this.privilagetEventStatus = {
            'new': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'accept_by_instructor': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 2,
                    'accept': 2,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'accepted_by_instructor': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 2,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'rejected_by_instructor': {
                'event': {
                    'check_presence': 0,
                    'edit': 2,
                    'cancel': 2,
                    'close': 0,
                    'discard': 0,
                    'accept': 2,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'published': {
                'event': {
                    'check_presence': 2,
                    'edit': 0,
                    'cancel': 2,
                    'close': 2,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 2,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2 // edytuj
                },
                'salon': {
                    'delete': 2 // usuń
                }
            },
            'finished': {
                'event': {
                    'check_presence': 2,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 0,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'cancelled': {
                'event': {
                    'check_presence': 0,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'cancelled_frequency': {
                'event': {
                    'check_presence': 0,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'cancelled_disease': {
                'event': {
                    'check_presence': 0,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            },
            'removed': {
                'event': {
                    'check_presence': 0,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0 // edytuj
                },
                'salon': {
                    'delete': 0 // usuń
                }
            }
        };
        this.privilegesRole = {
            'ROLE_SUPER_ADMIN': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 1,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
                'salon': {
                    'delete': 2
                }
            },
            'ROLE_ADMIN': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 1,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
                'salon': {
                    'delete': 2
                }
            },
            'ROLE_COORDINATOR': {
                'event': {
                    'check_presence': 2,
                    'edit': 2,
                    'cancel': 2,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 2 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 1,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
                'salon': {
                    'delete': 2
                }
            },
            'ROLE_SALES_REPRESENTATIVE': {
                'event': {
                    'check_presence': 2,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 2,
                    'check_presence': 0,
                    'delete': 1,
                    'edit': 0
                },
                'salon': {
                    'delete': 0
                }
            },
            'ROLE_DISTRIBUTOR': {
                'event': {
                    'check_presence': 2,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 2,
                    'edit': 0
                },
                'salon': {
                    'delete': 2
                }
            },
            'ROLE_INSTRUCTOR': {
                'event': {
                    'check_presence': 1,
                    'edit': 0,
                    'cancel': 0,
                    'close': 2,
                    'discard': 2,
                    'accept': 2,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 2,
                    'book': 0,
                    'check_presence': 2,
                    'delete': 2,
                    'edit': 2
                },
                'salon': {
                    'delete': 2
                }
            },
            'ROLE_EMPLOYEE': {
                'event': {
                    'check_presence': 0,
                    'edit': 0,
                    'cancel': 0,
                    'close': 0,
                    'discard': 0,
                    'accept': 0,
                    'delete': 0 // usuń
                },
                'student': {
                    'add': 0,
                    'book': 0,
                    'check_presence': 0,
                    'delete': 0,
                    'edit': 0
                },
                'salon': {
                    'delete': 0
                }
            }
        };
        this.userRole = this.usersService.me.role;
    }
    hasAccessRole(element, action) {
        if (this.privilegesRole[this.userRole][element]) {
            return this.privilegesRole[this.userRole][element][action];
        }
        return 3;
    }
    hasAccessEventStatus(status, element, action) {
        if (this.privilagetEventStatus[status][element]) {
            return this.privilagetEventStatus[status][element][action];
        }
        return 3;
    }
    hasAccessEventType(type, element, action) {
        if (this.privilagesEventType[type][element]) {
            return this.privilagesEventType[type][element][action];
        }
        return 3;
    }
}
PrivilegesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PrivilegesService_Factory() { return new PrivilegesService(i0.ɵɵinject(i1.UsersService)); }, token: PrivilegesService, providedIn: "root" });
